import { login, getAuthCode, registeredUser, regetPassword } from '../api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import Vue from 'vue'
const state = {
  token: getToken()
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  }
}
const actions = {
  // 登录
  login({ commit }, params) {
    // const username = params.userName.trim()
    return login(params).then(res => {
      const data = res
      setToken(data)
      commit('SET_TOKEN', data)
      return res
    })
  },
  // 更改信息刷新TOKEN

  refreshToken({ commit }, data) {
    console.log(data, 'refreshToken');
    setToken(data)
    commit('SET_TOKEN', data)
  },
  // 登出
  logout({ commit, state }) {
    commit('SET_TOKEN', '')
    // commit('SET_ROLES', [])
    removeToken()
    localStorage.removeItem('userInfo')
    localStorage.removeItem('fstat')
  },

  /* 获取邮箱验证码 */
  getAuthCode({ commit }, params) {
    // return getAuthCode(params)

    fetch(
      Vue.prototype.baseUrl + '/sms-code/sendSms',
      {
        method: "POST",
        headers: {
          "Content-Type":"application/json",
          // token: window.localStorage.getItem("token"),
        },
        body: params.phone,
        keepalive: true,
      },
    )
      .then((res) => res.json())
      .then(async (res) => {
        console.log(res);
        // if(res.flag){
        //   Vue.$message.success('成功获取验证码')
        //   debugger
        // }
        const tokenInfo = res.data;
        resolve(tokenInfo);
      })
      .catch(() => {});
  },

  /* 注册用户 */
  registeredUser({ commit }, params) {
    return registeredUser(params)
  },
  /**找回密码 */
  resetPassword({ commit }, params) {
    return regetPassword(params)
  }
}
export default {
  state,
  mutations,
  actions
}
